import { CommonModule } from "@angular/common";
import { Component, Input, OnInit, ViewChild } from "@angular/core";
import { NgxSpinnerModule, NgxSpinnerService } from "ngx-spinner";
import { MapSd1Component } from "../map-sd1/map-sd1.component";
import { TableComponent } from "../../components/common/table/table.component";
import { TitleTextPipe } from "../../custom.pipe";
import { FormGroup, FormBuilder, Validators,ReactiveFormsModule } from "@angular/forms";
import { ToastrService } from "ngx-toastr";
import { ApiService } from "../../api.service";
import { LfnPathGenerartionComponent } from "../../components/lfn-flow/lfn-path-generartion/lfn-path-generartion.component";
import { MessageComponent } from "../../components/common/message/message.component";
import {UploadFileComponent} from "../../components/common/upload-file/upload-file.component"


@Component({
  selector: "app-smp-connectivity-sd1",
  standalone: true,
  imports: [
    TableComponent,ReactiveFormsModule,
    CommonModule,
    MapSd1Component,MessageComponent,
    NgxSpinnerModule, TitleTextPipe,UploadFileComponent
  ],
  templateUrl: "./smp-connectivity-sd1.component.html",
  styleUrls: ["./smp-connectivity-sd1.component.scss"]
})

export class SmpConnectivitySd1Component implements OnInit {
  smp_connectivity_table: boolean = false;
  
  isLoading: boolean = false;
  myEquipmetForm: any = FormGroup;
  @Input() tableData: any;
  showTable: boolean = false;
  table2Data: any;
  showType2Table: boolean = false;
  showMap: boolean = false;
  mapData: any;
  showMessage: boolean = false;
  show_smp_table: boolean = false;
  showMultiPath: boolean = false;
  MessageToShow: any;
  url: string = '';
  filename: string = '';
  msg: string = ''; 
  @Input() inputData: any;
  tableData1:any;
  
  @ViewChild(TableComponent)
  tableChildComponent!: TableComponent;

  @ViewChild(MapSd1Component)
  mapChildComponent!: MapSd1Component;

  @ViewChild(LfnPathGenerartionComponent)
  lfnPathGeneration!: LfnPathGenerartionComponent;

  showEquipmetTable: boolean = false;
  map_div: boolean = true;
  success_path: boolean = false;
  upstream_screen: boolean = false;
  select_bjl: boolean = false;
  title: string = '';
  select_smp_screen: boolean = false;
  final_screen: boolean = false;
  showADRCard: boolean = false;
  selectedRow: any;
  flowName:string='SD1 ADR';
  myAdrForm!: FormGroup;
  alternate_path: boolean = false;
  file: string | null = null;
  select_bjl_structure_payload: any;

  constructor(private toastr: ToastrService,
    private fb: FormBuilder,
    private apiService: ApiService,
    private spinner: NgxSpinnerService
  )
  { 
      this.myEquipmetForm = this.fb.group({
            equpType: ['', Validators.required],
      });
      this.myAdrForm = this.fb.group({
        ADRpath: [''],
      });
  }
  
  ngOnInit() {
    
  if (this.inputData.message.includes(' mpt ')) {
      this.title = 'MPT';
    }
    else if (this.inputData.message.includes(' bjl ')) {
      this.title = 'BJL';      
    }
    else if (this.inputData.message.includes(' ajl ')) {
      this.title = 'AJL';      
    }
    else if (this.inputData.message.includes(' smp')) {
      this.title = 'SMP';      
    }
  }
  


  fileUploaded(event: string) {
    this.file = event;
  }

  receiveTableEvent(data:any) {    
    this.viewProfile(data);
    
  }

  viewProfile(data: any) {  
    // on select button clicked on table it'll call map component for pin point the structure id
    this.isLoading = true;
     
    if(
            ['select bjl structure sd1', 'select existing smp','select new smp'].includes(
              this.inputData.message
            )
    ) {
        if ('smp_lat' in data) {
          this.mapChildComponent.receiveTableEvent(data)
        }
    }
      else if (
      ['select mpt upstream equipment','select ajl upstream equipment'].includes(
        this.inputData.message
      )
    ) {
      this.inputData['selected_upstream_equipment'] = data;
      if (this.inputData.message == 'select ajl upstream equipment') {
        this.inputData['selected_ajl_upstream_equipment'] = [data];
      }
      
      this.apiService.selectUpstremEquipment(this.inputData).subscribe({
        next: (response) => {
          if(
            ['select bjl structure sd1', 'select mpt structure','select smp structure'].includes(
              response.message
            )
          ) {
            this.inputData = response;
            this.showTable = false;
            this.showEquipmetTable = false;
            this.tableData = response;
            this.tableChildComponent.initializeFunction(this.inputData);
            
            this.showMap = true;
            this.mapData = data;
            this.map_div = true;
            
          } else {
            this.toastr.error(
              response.message,
            'Error Message'
            );
          }
          this.isLoading = false;
        },
        error: (error) => {
          this.isLoading = false;
          
          this.toastr.error(
            `The API returned Unsuccessfull response : ${error}`,
            'Error Message'
          );
        },
      });
 
    }
    else {
      this.inputData['selected_path'] = data;
    }
  }

  OnSelectProceedMap(data: any) {
    // On Button click call jl structure api and based on response trigger next step
    
      this.isLoading = true;
      this.spinner.show();
      this.showTable = false;
      let smp_state_count = 0;
      let smp_state_count_error = 0;
      if ('locations_served_from_smp' in this.inputData) {
          for (let i = 0; i < this.inputData.locations_served_from_smp.length; i++){
                if ('smp_state' in this.inputData.locations_served_from_smp[i]) {
                    if (this.inputData.locations_served_from_smp[i].smp_state == 'yes'){
                      if('new_location' in this.inputData.locations_served_from_smp[i] || 'suggested_location_id' in this.inputData.locations_served_from_smp[i]){
                        console.log('true')
                      }
                      else{
                        alert('Please provide a new location or the suggested_location; otherwise, select No to proceed without action. For '+ this.inputData.locations_served_from_smp[i].smp_id + ' and port ' + this.inputData.locations_served_from_smp[i].smp_port)
                      }
                    }
                    smp_state_count++;
                }
                else {
                  //smp_state_count_error++;
                    this.inputData.locations_served_from_smp[i]['smp_state'] = 'no';
            }
            
            
            }
      }
      if(smp_state_count_error>0){
        this.toastr.error(
                'select all mandatory fields.',
              'Error Message'
            );
        this.isLoading = false;
        this.spinner.hide();
      }
      else {
        const uniqueArray = this.inputData.selected_smp.filter((o: any, index: any, arr: any[]) =>
                arr.findIndex((item: any) => JSON.stringify(item) === JSON.stringify(o)) === index
            );
        console.log(uniqueArray);
        this.inputData.selected_smp = uniqueArray
    this.apiService.selectSmpLocationSD1(this.inputData).subscribe({
      next: (response) => {
      
        if (response.message === "select bjl sd1") {
            this.map_div = false;
            this.inputData = response;
            this.select_bjl = true;   
            this.tableData = response;
        }
        else if (response.message == "select existing smp") {
          this.inputData = response;
          this.tableData = response;
            this.tableChildComponent.initializeFunction(this.inputData);            
            this.showMap = true;
            this.mapData = data;
            this.map_div = true;
            this.mapChildComponent.receiveTableEvent(this.inputData,'yes');
        }
        else if (response.message === 'select upstream equipment sd1') {
              this.map_div = false;
              this.select_bjl = false;
              this.upstream_screen = true;
              this.inputData = response;
              this.tableData = response;
              this.tableChildComponent.initializeFunction(this.inputData);
          if ('error_messgae' in response) {
                this.toastr.error(
                    response.error_messgae,
                  'Error Message'
                );
              }
        }
        else if (response.message == 'sd1 process completed') {
              this.map_div = false;
              this.select_smp_screen = false;
              this.upstream_screen = false;
              this.select_bjl = false;
              this.final_screen = true;
              this.tableData = response;
              this.inputData = response;
        }
        else {
            this.toastr.error(
                response.message,
              'Error Message'
            );
          }

        this.isLoading = false;
        this.spinner.hide();
      },
        error: (error) => {
          this.isLoading = false;
          this.spinner.hide();
          window.alert(`The API returned Unsuccessfull response : ${error}`);
        },
      });
    
    }
    }

  receiveTableEventBJL(data:any) {
    this.inputData['selected_bjl'] = data;
    this.isLoading = true;
    this.spinner.show()  
    this.apiService.selectBjlSD1(this.inputData).subscribe({
      next: (response) => {

            if (response.message === 'select smp structure') {
              this.select_bjl = false;
              this.upstream_screen = false;
              this.inputData = response;
              this.select_smp_screen = true;
              this.show_smp_table = true;
              this.tableData = response;
            }
            else if (response.message == 'select bjl sd1') {
              this.select_bjl = true;
              this.upstream_screen = false;
              this.inputData = response;
              this.tableData = response;
              this.tableChildComponent.initializeFunction(this.inputData);
            }
            else if (response.message == 'select upstream equipment sd1') {
              this.map_div = false;
              this.select_bjl = false;
              this.upstream_screen = true;
              this.inputData = response;
              this.tableData = response;
              this.tableChildComponent.initializeFunction(this.inputData);
            }
            else {              
              if ('file_name' in response) {
                this.select_bjl = false;
                this.upstream_screen = false;
                this.showMessage = true;
                this.MessageToShow = response;
              } else {
                this.toastr.error(response.message, 'Error Message');
                console.log('error');
              }
            }

            this.isLoading = false;
            this.spinner.hide();
            // window.alert(response.messgae);
      }
      ,
      error: (error) => {
            this.isLoading = false;
            this.spinner.hide();
            this.toastr.error(
              `The API returned Unsuccessfull response : ${error}`,
              'Error Message'
            );
            //window.alert(`The API returned Unsuccessfull response : ${error}`);
          },
    });
  }

  callBJL() {
    this.isLoading = true;
    this.spinner.show()  
    this.apiService.bjlpathoverwriteSD1(this.inputData).subscribe({
        next: (response) => {
        if (response.message == 'select upstream equipment sd1') {
            this.map_div = false;
          this.select_bjl = false;
          this.select_smp_screen = false;
              this.upstream_screen = true;
              this.inputData = response;
              this.tableData = response;
              this.tableChildComponent.initializeFunction(this.inputData);
          } else {
            //this.showTable = false;
            this.toastr.error(
            `The API returned Unsuccessfull response`,
            'Error Message'
          );
          }

          this.isLoading = false;
          this.spinner.hide();
        },
        error: (error) => {
          this.isLoading = false;
          this.spinner.hide();
          this.toastr.error(
            `The API returned Unsuccessfull response : ${error}`,
            'Error Message'
          );
        },
      });
  }

  OnSelectProceedMapSelectSMP(data: any) {
    this.isLoading = true;
      this.spinner.show()  
    
    this.apiService.selectSmpStructure(this.inputData,this.inputData.message).subscribe({
      next: (response) => {
            
            if (response.message === 'select smp structure') {
              this.select_bjl = false;
              this.upstream_screen = false;
              this.inputData = response;
              this.tableData = response;
              this.select_smp_screen = true;
              this.show_smp_table = true;
              //this.tableChildComponent.initializeFunction(this.inputData);
              //this.mapChildComponent.receiveTableEvent(this.inputData);
            }
            else if (response.message == 'select bjl structure sd1') {
              this.map_div = false;
              this.select_bjl = false;
              this.upstream_screen = false;
              this.inputData = response;
              this.tableData = response;
              this.select_smp_screen = true;
              this.show_smp_table = false;
              this.select_bjl_structure_payload = response;
              //this.tableChildComponent.initializeFunction(this.inputData);
              this.mapChildComponent.receiveTableEvent(this.inputData);
            }
            else if (response.message == 'select new smp') {
              this.map_div = true;
              this.select_smp_screen = false;
              this.upstream_screen = false;
              this.select_bjl = false;
              this.tableData = response;
              this.inputData = response;
            }
              else if (response.message == 'sd1 process completed') {
              this.map_div = false;
              this.select_smp_screen = false;
              this.upstream_screen = false;
              this.select_bjl = false;
              this.final_screen = true;
              this.tableData = response;
              this.inputData = response;
              }
            else {              
              if ('file_name' in response) {
                this.select_bjl = false;
                this.upstream_screen = false;
                this.showMessage = true;
                this.MessageToShow = response;
              } else {
                this.toastr.error(response.message, 'Error Message');
                console.log('error');
              }
            }

            this.isLoading = false;
            this.spinner.hide();
      }
      ,
      error: (error) => {
            this.isLoading = false;
            this.spinner.hide();
            this.toastr.error(
              `The API returned Unsuccessfull response : ${error}`,
              'Error Message'
            );
          },
    });
  }

  receiveTableEventStructureSelectSMP(data: any) {
    this.mapChildComponent.receiveTableEvent(data,'bjl_smp')
  }

  receiveTableEventUpstream(data: any) {
    this.inputData['selected_upstream_equipment'] = data;
    this.isLoading = true;
    this.spinner.show();
    this.apiService.selectUpstreamStructure(this.inputData).subscribe({
      next: (response) => {

        if (response.message === 'select bjl structure sd1') {
              this.map_div = false;
              this.select_bjl = false;
              this.upstream_screen = false;
              this.inputData = response;
              this.select_smp_screen = true;
              this.show_smp_table = false;
          this.tableData = response;
          this.select_bjl_structure_payload = response;
            }            
            else {              
              if ('file_name' in response) {
                this.select_bjl = false;
                this.upstream_screen = false;
                this.showMessage = true;
                this.MessageToShow = response;
              } else {
                this.toastr.error(response.message, 'Error Message');
                console.log('error');
              }
            }

            this.isLoading = false;
            this.spinner.hide();
            // window.alert(response.messgae);
      }
      ,
      error: (error) => {
            this.isLoading = false;
            this.spinner.hide();
            this.toastr.error(
              `The API returned Unsuccessfull response : ${error}`,
              'Error Message'
            );
            //window.alert(`The API returned Unsuccessfull response : ${error}`);
          },
    });
  }

  receiveTableEventFinalCall() {
    this.isLoading = true;
      this.spinner.show();  
      this.showMultiPath = false;
      this.final_screen = false;
      this.showADRCard = true;
      this.isLoading = false;
      this.spinner.hide();  
    this.apiService.generateSd1Output(this.inputData).subscribe({
      next: (response) => {
          
                if (response.message == 'Pre-signed url has been generated') {
                  this.map_div = false;
                  this.select_smp_screen = false;
                  this.upstream_screen = false;
                  this.select_bjl = false;
                  this.final_screen = false;
                  this.showMessage = true; 
                  this.url = response.url;
                  this.filename = response.file_name;
                  this.msg = response.message;
                  this.MessageToShow = JSON.stringify(response);
                }
                else if (response.message == 'upload adr') {
                  this.showADRCard = true;
                  this.map_div = false;
                  this.select_smp_screen = false;
                  this.upstream_screen = false;
                  this.select_bjl = false;
                  this.final_screen = false;
                  this.inputData = response;
                  this.tableChildComponent.initializeFunction(this.inputData);
                }
                else {              
                  if ('file_name' in response) {
                    this.select_bjl = false;
                    this.upstream_screen = false;
                    this.showMessage = true;
                    this.MessageToShow = response;
                  } else {
                    this.toastr.error(response.message, 'Error Message');
                    console.log('error');
                  }
                }

            this.isLoading = false;
            this.spinner.hide();
      },
      error: (error) => {
            this.isLoading = false;
            this.spinner.hide();
            this.toastr.error(
              `The API returned Unsuccessfull response : ${error}`,
              'Error Message'
            );
          },
    });
  }

  table_function_called() {
    this.isLoading = true;
    this.spinner.show();
    if (this.selectedRow && this.selectedRow.length > 0) {
      let new_route_list = [];
      for (let ele of this.selectedRow) {
        new_route_list.push(ele['Paths']);
      }
      this.inputData['new_route_list'] = new_route_list;
    }
    this.inputData['adr_path'] = this.myAdrForm.value.ADRpath;
    this.inputData['adr_file_name'] = this.file;

    this.inputData['available_paths'] = this.inputData['available_paths'];
    this.apiService.onadrcallSD1(this.inputData).subscribe({
      next: (response) => {
        this.showADRCard = false;

        if (
          response.message.indexOf(
            "Tool generated path doesn't match with ADR"
          ) != -1
        ) {
          this.url = response.url;
          this.filename = response.file_name;
          this.msg = response.message;
          this.showMessage = true;
          this.MessageToShow = JSON.stringify(response);
        } else if (response.message == 'Pre-signed url has been generated') {
          this.url = response.url;
          this.filename = response.file_name;
          this.msg = response.message;
          this.showMessage = true;
          this.MessageToShow = JSON.stringify(response);
        }
        else if(response.message == 'alternate path'){
            this.showADRCard = false;
            this.alternate_path = true;    
            this.inputData =  response;  
            //this.tableChildComponent.initializeFunction(this.inputData);
        } 
        else {
          this.url = response.url;
          this.filename = response.file_name;
          this.msg = response.message;
          this.showMessage = true;
          this.MessageToShow = JSON.stringify(response);
        }
        this.isLoading = false;
        this.spinner.hide();
        // window.alert(response.messgae);
      },
      error: (error) => {
        this.isLoading = false;
        this.spinner.hide();
        this.toastr.error(
          `The API returned Unsuccessfull response : ${error}`,
          'Error Message'
        );
        //window.alert(`The API returned Unsuccessfull response : ${error}`);
      },
    });
  }

  receiveTableEventFinal(data:any){
    this.isLoading = true;
      this.spinner.show();  
      this.map_div = false;
      this.showMultiPath = false;
      this.inputData.message = 'sd1 process completed'
      this.inputData["table_columns"]=[
                                        "smp_id",
                                        "smp_state",
                                        "location_id",
                                        "distance"
                                     ]
      //this.inputData = this.tableData1;
      this.final_screen = true;
      this.tableChildComponent.initializeFunction(this.inputData);
      this.isLoading = false;
      this.spinner.hide();

  }
  
}
